export enum RaptorMetricType {
  Volume = 1,
  Area = 2,
  Weight = 3,
  Length = 4,
  Loads = 5,
  Hours = 6,
  Count = 7,
  Other = 8
}
